import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { downloadFile } from "../utils/downloadFile";

const fetchDownloadFeatureFile = async (id, name) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  try {
    const downloadUrl = `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=genFeatureFile&companyid=${user.companyid}&testcaseid=${id}&testcasename=${name}`;
    await downloadFile(downloadUrl, { filename: `${name}.feature` });
  } catch (error) {
    console.log(error.response?.data?.error || error);
    throw error;
  }
};

const useDownloadFeatureFileQuery = (id, name) => {
  return useQuery({
    queryKey: ["downloadcode", id],
    queryFn: () => fetchDownloadFeatureFile(id, name),
    retry: true,
    enabled: false,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export default useDownloadFeatureFileQuery;
